<template>
	<div class="l-container works">
		<div class="recently-project-wrap">
			<h1 class="page-tit">UI/UX</h1>
			<!-- Thumbnail View : s -->
			<div class="view-area">
				<div class="is-active">
					<div class="select-box-wrap">
						<div class="select-box tab">
							<div class="swiper-container tab-swiper">
								<ul class="swiper-wrapper">
									<li class="swiper-slide is-active">
										<a
											href="javascript:;"
											@click="sortingByCategory('All', $event)"
											>All</a
										>
									</li>
									<li class="swiper-slide">
										<a
											href="javascript:;"
											@click="sortingByCategory('Corporation', $event)"
											>Corporation</a
										>
									</li>
									<li class="swiper-slide">
										<a
											href="javascript:;"
											@click="sortingByCategory('e-Commerce', $event)"
											>e-Commerce</a
										>
									</li>
									<li class="swiper-slide">
										<a
											href="javascript:;"
											@click="sortingByCategory('Finance', $event)"
											>Finance</a
										>
									</li>
									<li class="swiper-slide">
										<a
											href="javascript:;"
											@click="sortingByCategory('Travel', $event)"
											>Travel</a
										>
									</li>
									<li class="swiper-slide">
										<a
											href="javascript:;"
											@click="sortingByCategory('System', $event)"
											>System</a
										>
									</li>
									<li class="swiper-slide">
										<a
											href="javascript:;"
											@click="sortingByCategory('Etc', $event)"
											>Etc</a
										>
									</li>
								</ul>
							</div>
						</div>
						<div class="select-box select">
							<a
								href="javascript:;"
								@click="toggleYearSelect"
								:class="{ 'is-active': yearSelectOpen }"
								>연도 선택</a
							>
							<ul class="year-list">
								<li class="is-active">
									<a href="javascript:;" @click="sortingByYear('all', $event)"
										>All</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2021', $event)"
										>2021</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2020', $event)"
										>2020</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2019', $event)"
										>2019</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2018', $event)"
										>2018</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2017', $event)"
										>2017</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2016', $event)"
										>2016</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2015', $event)"
										>2015</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2014', $event)"
										>2014</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2013', $event)"
										>2013</a
									>
								</li>
								<li>
									<a href="javascript:;" @click="sortingByYear('2012', $event)"
										>2012</a
									>
								</li>
							</ul>
						</div>
					</div>
					<div class="recently-project" v-if="projectSize">
						<ul>
							<li
								v-for="(project, index) in projectCurrent"
								:key="index"
								:data-category="project.category"
								:data-year="project.prjyear"
							>
								<template v-if="'prjUrl' in project">
									<router-link :to="'/uiux/' + project.prjUrl">
										<img
											v-lazy="project.imgsrc"
											:alt="'lazy' + project.imgalt"
											v-if="lazyOK"
										/>
										<img
											:src="project.imgsrc"
											:alt="'nolazy' + project.imgalt"
											v-else
										/>
										<p>
											<strong class="tit" v-text="project.prjtitle"></strong>
											<span v-text="project.prjname"></span>
										</p>
									</router-link>
									<!-- <a :href="'/uiux/' + project.prjUrl">
					<img v-lazy="project.imgsrc" :alt="'lazy'+project.imgalt" v-if="lazyOK">
					<img :src="project.imgsrc" :alt="'nolazy'+project.imgalt" v-else>
					<p>
					  <strong class="tit" v-text="project.prjtitle"></strong>
					  <span v-text="project.prjname"></span>
					</p>
				  </a> -->
								</template>
								<template v-else>
									<div>
										<p>
											<strong class="tit" v-text="project.prjname"></strong>
											<span v-text="project.prjtitle"></span>
										</p>
										<dl>
											<dt v-text="project.prjyear"></dt>
											<dd class="img">
												<img
													v-lazy="project.imgsrc"
													:alt="project.imgalt"
													v-if="lazyOK"
												/>
												<img
													:src="project.imgsrc"
													:alt="project.imgalt"
													v-else
												/>
											</dd>
										</dl>
									</div>
								</template>
							</li>
						</ul>
					</div>
					<div class="message" v-else>해당하는 프로젝트가 없습니다.</div>
				</div>
				<!-- Thumbnail View : e -->
			</div>
		</div>
		<br />
		<router-view></router-view>
	</div>
</template>

<style>
@import "../../static/css/swiper.min.css";
/* if use swiper.min.js */
@import "../../static/css/jquery-ui.min.css";
/* if use swiper.min.js */
</style>
<script>
import { store } from "../data/store.js";
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
export default {
	data() {
		return {
			store,
			noneHref: null,
			currentRoute: window.location.pathname,
			projectCurrent: {},
			lazyOK: true,
			yearSelectOpen: false,
			sortingCondition: {
				category: "all",
				year: "all",
			},
			projectSize: true,
		};
	},
	mounted: function () {
		//console.log('mounted')

		// mobile tab menu swiper control
		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".tab-swiper", {
					slidesPerView: "auto",
					spaceBetween: 20,
					grabCursor: true,
					loop: false,
					slideToClickedSlide: true,
				});
			}
		};

		winW = $window.outerWidth();
		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}

		$window.on("resize", function () {
			winW = $window.outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
				}
			}
		});

		// filter select control
		var $pjList = $(".recently-project").find("li");
		$(".select-box").off("click", "a", function () {
			var $select = $(".select-box.select").children("ul");
			if ($(this).parent("li").length) {
				var txt = $(this).text();
				var txtLowerCase = txt.toLowerCase();
				$(this)
					.parent("li")
					.addClass("is-active")
					.siblings("li")
					.removeClass("is-active");
				$select.slideUp();

				//tab
				if ($(this).closest(".select-box").hasClass("tab")) {
					$pjList.hide();
					var selectSorted = $(".select-box.select")
						.find("li.is-active")
						.text()
						.toLowerCase();
					$pjList.each(function () {
						var category = $(this).attr("data-category").toLowerCase();
						if (category == txtLowerCase) {
							var $this = $(this);
							$this.show();
							if (selectSorted !== "all") {
								var year = $this.attr("data-year");
								if (year !== selectSorted) {
									$this.hide();
								}
							}
							// if(category.indexOf(txtLowerCase) >= 0){
							//     var $this = $(this);
							//     $this.show();
							// }
						}
						if (txtLowerCase == "all") {
							$pjList.show();
							$pjList.each(function () {
								var $this = $(this);
								if (selectSorted !== "all") {
									var year = $this.attr("data-year");
									if (year !== selectSorted) {
										$this.hide();
									}
								}
							});
						}
					});
					if ($pjList.is(":visible")) {
						$(".recently-project-wrap .message").hide();
					} else {
						$(".recently-project-wrap .message").show();
					}
					//select
				} else {
					$(".select-box.select").children("a").text(txt);
					$pjList.hide();
					var tabSorted = $(".select-box.tab")
						.find(".is-active")
						.text()
						.toLowerCase();
					$pjList.each(function () {
						var year = $(this).attr("data-year");
						if (year == txt) {
							var $this = $(this);
							$this.show();
							if (tabSorted !== "all") {
								var category = $this.attr("data-category");
								if (category !== tabSorted) {
									$this.hide();
								}
							}
						}
						if (txtLowerCase == "all") {
							$pjList.show();
							$pjList.each(function () {
								var $this = $(this);
								if (tabSorted !== "all") {
									var category = $this.attr("data-category");
									if (category !== tabSorted) {
										$this.hide();
									}
								}
							});
						}
					});
					if ($pjList.is(":visible")) {
						$(".recently-project-wrap .message").hide();
					} else {
						$(".recently-project-wrap .message").show();
					}
				}
			} else {
				if ($select.is(":hidden")) {
					$select.slideDown();
				} else {
					$select.slideUp();
				}
			}
		});

		//window back button click
		//   window.onpopstate = function (event) {
		// 	location.href = '/uiux';
		//   }

		// random
		// var generateRandom = function (min, max) {
		//     var ranNum = Math.floor(Math.random()*(max-min+1)) + min;
		//     return ranNum;
		// }
		// var maxVal = $pjList.length;
		// $pjList.each( function(idx){
		//     $(this).css('transition-delay', '0.' + generateRandom(0, maxVal) + 's');
		// });
		// setTimeout( function(){
		//     $pjList.removeClass('is-hidden');
		// }, 80);
	},
	methods: {
		sortingByCondition() {
			if (this.sortingCondition.category != "all") {
				if (this.sortingCondition.year != "all") {
					this.projectCurrent = this.store.projects.filter(
						(v) =>
							v.prjyear.toLowerCase() == this.sortingCondition.year &&
							v.category.toLowerCase() == this.sortingCondition.category
					);
				} else {
					this.projectCurrent = this.store.projects.filter(
						(v) => v.category.toLowerCase() == this.sortingCondition.category
					);
				}
				this.lazyOK = false;
			} else {
				if (this.sortingCondition.year != "all") {
					this.projectCurrent = this.store.projects.filter(
						(v) => v.prjyear.toLowerCase() == this.sortingCondition.year
					);
					this.lazyOK = false;
				} else {
					this.projectCurrent = this.store.projects;
					this.lazyOK = true;
				}
			}
			//console.log(this.projectSize, this.projectCurrent.length)

			this.projectSize = this.projectCurrent.length != 0 ? true : false;
		},
		sortingByCategory(category, event) {
			category = category.toLowerCase();
			this.sortingCondition.category = category;

			this.sortingByCondition();

			//TAB Activation
			let $siblings = Array.prototype.slice.call(
				event.currentTarget.closest(".swiper-wrapper").children
			);

			$siblings.forEach(function (el) {
				el.classList.remove("is-active");
			});
			event.currentTarget.parentNode.classList.add("is-active");

			//연도 닫기
			document
				.querySelector(".select")
				.firstChild.classList.remove("is-active");
		},
		sortingByYear(year, event) {
			year = year.toLowerCase();
			this.sortingCondition.year = year;

			this.sortingByCondition();

			if (year != "all") {
				event.currentTarget.closest(".select").firstChild.innerText = year;
			} else {
				this.projectCurrent = this.store.projects;
				this.lazyOK = true;
				event.currentTarget.closest(".select").firstChild.innerText =
					"연도 선택";
			}
			this.yearSelectOpen = false;

			//TAB Activation
			let $siblings = Array.prototype.slice.call(
				event.currentTarget.closest(".year-list").children
			);

			$siblings.forEach(function (el) {
				el.classList.remove("is-active");
			});
			event.currentTarget.parentNode.classList.add("is-active");
		},
		//    sortingByCategory(category, event){
		//        category = category.toLowerCase();
		//        if(category != 'all'){
		//            this.projectCurrent = this.store.projects.filter( v => v.category.toLowerCase() == category);
		//            this.lazyOK = false;
		//        }else{
		//            this.projectCurrent = this.store.projects;
		//            this.lazyOK = true;
		//        }

		//        //TAB Activation
		//        let $siblings = Array.prototype.slice.call(event.currentTarget.closest('.swiper-wrapper').children);

		//         $siblings.forEach(function(el) {
		//             el.classList.remove('is-active');
		//         })
		//         event.currentTarget.parentNode.classList.add('is-active');
		//    },
		//    sortingByYear(year, event){
		//        year = year.toLowerCase();
		//        if(year != 'all'){
		//            this.projectCurrent = this.store.projects.filter( v => v.prjyear.toLowerCase() == year);
		//            this.lazyOK = false;
		//            event.currentTarget.closest('.select').firstChild.innerText = year;
		//        }else{
		//            this.projectCurrent = this.store.projects;
		//            this.lazyOK = true;
		//            event.currentTarget.closest('.select').firstChild.innerText = '연도 선택';
		//        }
		//        this.yearSelectOpen = false;

		//        //TAB Activation
		//        let $siblings = Array.prototype.slice.call(event.currentTarget.closest('.year-list').children);

		//         $siblings.forEach(function(el) {
		//             el.classList.remove('is-active');
		//         })
		//         event.currentTarget.parentNode.classList.add('is-active');
		//    },
		toggleYearSelect() {
			this.yearSelectOpen = !this.yearSelectOpen;
		},
	},
	created() {
		this.projectCurrent = store.projects;
		console.log("xgUI/UX");
	},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/XgWorks.vue